const baseColor = '#333d47'

export const checkoutStyles = {
  base: {
    fontSize: '15px',
    lineHeight: '24px',
    padding: '0 0.75rem',
    display: 'flex',
    alignItems: 'center',
    minHeight: '3rem',
    height: '3rem',
    letterSpacing: 0,
    fontFamily: 'Avenir, Roboto, sans-serif',
    color: baseColor,
  },
  placeholder: {
    base: {
      opacity: 0,
    },
  },
}
